/**
 * Form texts
 * @typedef {Object} FormTexts
 * @property {string} title
 * @property {string[]} subtitles
 * @property {string} [submitText]
 */

/**
 * Creates title, subtitles and submit-text properties.
 * @param {{ edit: FormTexts?, create: FormTexts?}} [keys] - the text keys for each form mode (create, edit)
 */
const useFormMode = (modes) => {
  return {
    props: {
      mode: {
        type: String,
        validator: function (value) {
          return ['create', 'edit'].indexOf(value) !== -1
        },
        required: true
      }
    },
    computed: {
      title () {
        return this.$t(this[modes][this.mode].title)
      },
      subtitles () {
        return this[modes][this.mode].subtitles.map(key => this.$t(key))
      },
      submitText () {
        return this.$t(this[modes][this.mode].submitText || `shared.${this.mode}`)
      }
    }
  }
}

export default useFormMode
